module.exports = __webpack_public_path__ + "assets/img/success.995426df.svg";